import config from '../config'
import { builderState } from 'common/composable/manageBuilderState'
import { bulkActionsState } from '../composable/bulkActions'
import { inject } from 'vue'
import { appState } from 'common/composable/appState'

export function useRouteRedirection() {
  const route: any = inject('route')
  const emitter: any = inject('emitter')

  function routeBack() {
    const fullPath = bulkActionsState.editMode
      ? `/location/${appState.locationId}/marketing/emails/scheduled`
      : `/location/${appState.locationId}/marketing/emails/all`
    try {
      let query = {}
      if (appState.folderId || !builderState.lastSavedOn) {
        query = route?.query
      }
      emitter.emit('email_preview-exit-email-builder', {
        message: `The page contains unsaved changes. Do you still wish to leave the page?`,
        test: 'event from router preview',
        router: fullPath,
        unsavedChanges: builderState.unsavedChanges,
        name: 'emails_home-v2-templates',
        query: query,
      })
    } catch (error) {
      console.log('error ', error)
      window.location.href = `${config.listingAppUrl}${fullPath}`
    }
  }
  return { routeBack }
}
